import React from 'react';
import ReactDOM from 'react-dom';
import Routing from "./Routing";
import './index.css';
import {observable} from 'mobx';
import ViewState from './ViewState';

let url = window.location.href;
let viewState = ViewState.table;
if (url && url.indexOf('/coin/') >= 0) {
    viewState = ViewState.detail;
}

let selectedCurrency = {symbol: 'USD', name: 'United States Dollar', value: 1.0, prefix: '$'};

try {
    let currency = JSON.parse(window.localStorage.currency);
    if (currency && currency.symbol && currency.value) {
        selectedCurrency = currency;
    }
} catch (err) {
    // Nothing.
}


let appState = observable({
    coins: [],
    selectedCoin: {},
    selectedSymbol: '',
    selectedCoinChart: [],
    sort: 'cap', // name, symbol etc
    sortDirection: 'desc',
    searchQuery: '',
    searchResults: {},
    searchCursor: 0,
    searchSelectedCoin: null,
    favourites: [], // A list of favourite symbols so we display them at the top
    updated: '',
    viewState: viewState,
    currencies: [],
    currency: selectedCurrency,
    updateCoins: () => {}
});

ReactDOM.hydrate(<Routing appState={appState} />, document.getElementById('root'));

try {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            registration.unregister()
        } })
} catch (err) {

}


// WEBPACK FOOTER //
// ./src/index.js